export default __webpack_public_path__ + "static/media/D. K. Pattanaik.b17e4269.JPG";